export default "__VITE_ASSET__Du3IBniv__"